import { Link, type SxProps, type Theme } from '@mui/material';
import { useCookieConsent } from '../contexts/cookie-consent-context';

type Props = {
    sx?: SxProps<Theme>;
};

/** Re-opens the cookie consent banner (legacy footer "Cookie settings" link). */
export function CookieSettingsLink({ sx }: Props) {
    const { openCookieSettings } = useCookieConsent();

    return (
        <Link
            component="button"
            type="button"
            onClick={openCookieSettings}
            sx={[
                { color: 'inherit', fontSize: 'inherit', verticalAlign: 'baseline' },
                ...(Array.isArray(sx) ? sx : sx ? [sx] : [])
            ]}
        >
            Cookie settings
        </Link>
    );
}
